import { isLiveBackend, read } from './http';
import type { ApiHealth } from '@/types/system';

/**
 * GET /health
 *
 * The one endpoint the API implements today. Used by the console to show
 * whether the backend is actually reachable, rather than leaving operators to
 * guess when a screen is showing fixture data.
 */
export function getApiHealth(signal?: AbortSignal): Promise<ApiHealth> {
  return read(
    '/health',
    () => ({
      status: 'ok' as const,
      uptimeSeconds: 0,
      timestamp: new Date().toISOString(),
      environment: 'fixtures',
    }),
    signal,
  );
}

export { isLiveBackend };
